import { Link } from 'react-router-dom';
import { comments } from '@/mocks/comments';
import SectionTitle from '@/components/feature/SectionTitle';

export default function ReviewsSection() {
  const displayComments = comments.slice(0, 6);

  return (
    <section className="bg-background-100 py-12 md:py-16">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <SectionTitle
          title="网友吃瓜热评"
          subtitle="REVIEWS"
          align="center"
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {displayComments.map((comment) => (
            <div
              key={comment.id}
              className="bg-background-50 rounded-xl border border-background-200/70 p-5 hover:border-primary-200 transition-all hover:shadow-sm"
            >
              <div className="flex items-center gap-0.5 mb-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <span key={i} className="text-accent-400 text-sm">
                    {i < comment.rating ? (
                      <i className="ri-star-fill" />
                    ) : (
                      <i className="ri-star-line" />
                    )}
                  </span>
                ))}
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-4 line-clamp-3">
                {comment.content}
              </p>
              <div className="flex items-center gap-3">
                <img
                  src={comment.avatar}
                  alt={comment.username}
                  className="w-10 h-10 rounded-full object-cover bg-background-200"
                  loading="lazy"
                />
                <div>
                  <p className="text-sm font-semibold text-foreground-800">{comment.username}</p>
                  <p className="text-xs text-foreground-400">{comment.date}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}